import React from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, Link } from "react-router-dom";
import { replace } from 'connected-react-router';
import { useFlag } from '@innovid/feature-flags-react';
import { FEATURE_FLAGS } from "featureFlag/featureFlag";

import { LibraryActionList } from "widgets/grid/cells/LibraryActions";

import "./CreativesInfoHeader.css";

export function isCreatives(match, location){
	if(/\/library\/\d*\/?$/gi.test(location.pathname)){
		return true;
	}
	return false;
}

export function isAssets(match, location){
	if(/\/library\/\d*\/assets\/?$/gi.test(location.pathname)){
		return true;
	}
	return false;
}

export function isPreview(match, location){
	if(/\/library\/\d*\/previews\/?$/gi.test(location.pathname)){
		return true;
	}
	return false;
}

export function isQrCodes(match, location){
	if(/\/library\/\d*\/qr-designs\/?.*$/gi.test(location.pathname)){
		return true;
	}
	return false;
}

export function isContentFeed(match, location){
	if(/\/library\/\d*\/content-feeds\/?$/gi.test(location.pathname)){
		return true;
	}
	return false;
}

export default function CreativesInfoHeader(props){
	const dispatch = useDispatch();
	const handleDeleteSuccess = () => dispatch(replace('/libraries/'));
	const isContentFeedsTabEnabled = useFlag(FEATURE_FLAGS.CONTENT_FEEDS_TAB_FEATURE_FLAG);
	let currentLibrary = useSelector(state => state.libraryProperties)
		, isLoaded = currentLibrary.isLoaded && currentLibrary.id === parseInt(props.libraryId)
		, isLoadedClass = isLoaded ? "" : "is-loading"
		// , $topName = <Link to={`/library/${currentLibrary.id}/`}>{`${currentLibrary.name} (${currentLibrary.id})`}</Link>
		, itemName = currentLibrary.name
		, itemId = currentLibrary.id
		, $links = [
			<NavLink
				key="creatives"
				className="tab-item flex-center"
				isActive={isCreatives}
				activeClassName="active-link" to={`/library/${props.libraryId}/`}><span className="tab-name">Creatives</span></NavLink>
			, <NavLink
				key="assets"
				className="tab-item flex-center"
				isActive={isAssets}
				activeClassName="active-link" to={`/library/${props.libraryId}/assets/`}><span className="tab-name">Assets</span></NavLink>
			, <NavLink
				key="qrcodes"
				className="tab-item flex-center"
				isActive={isQrCodes}
				activeClassName="active-link" to={`/library/${props.libraryId}/qr-designs/`}><span className="tab-name">QR Codes</span></NavLink>
			, <NavLink
				key="previews"
				className="tab-item flex-center"
				isActive={isPreview}
				activeClassName="active-link" to={`/library/${props.libraryId}/previews/`}><span className="tab-name">Previews</span></NavLink>
			, isContentFeedsTabEnabled && <NavLink
				key="content-feeds"
				className="tab-item flex-center"
				isActive={isContentFeed}
				activeClassName="active-link" to={`/library/${props.libraryId}/content-feeds/`}><span className="tab-name">Bulk Sheets</span></NavLink>
			, <LibraryActionList
				key="actions"
				className="flex-center large-action-menu"
				libraryId={props.libraryId}
				libraryName={currentLibrary.name}
				onLibraryDeleteSuccess={handleDeleteSuccess}
			/>
		]
		;

	return (
		<section className={`info-header info-header-tabs library-info flex-between ${isLoadedClass}`}>
			<header className="camp-name flex-around">
				<div className="upper-group flex-center blank-load">
					<h4 className="advertiser">
						<span className="breadcrumb">
							<Link to="/libraries/">Creative Libraries</Link>
						</span>
						{currentLibrary.advertiserName}
					</h4>
					{/* <span className="camp-label">{$topName}</span> */}
				</div>
				<div className="lower-group flex-center blank-load">
					<h3 className="campaign" title={itemName}>
						<span className="campaign-name">{itemName}</span>
						<span className="camp-id">{itemId}</span>
					</h3>
				</div>
			</header>
			<aside className="tabs">{$links}</aside>
		</section>
	);
}

export const PRIVATE = {
	isCreatives,
	isAssets,
	isPreview,
	isQrCodes,
	isContentFeed,
};

CreativesInfoHeader.displayName = "CreativesInfoHeader";
CreativesInfoHeader.propTypes = {
	libraryId: PropTypes.string.isRequired,
};
